.autocompleteProductCard {
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 16px 24px;
  border-top: 0.5px solid var(--colors-grays-light);
  width: 100%;
}

.badgesContainer {
  display: flex;
  gap: 2px;
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  padding: 8px;
  justify-content: center;
}

.badgesContainer:has(> :only-child) {
  justify-content: flex-end;
}

.autocompleteProductCardImg {
  position: relative;
}

.specialBadge {
  text-align: center;
  border-radius: 16px;
  max-width: 50px;
  height: 24px;
  padding: 0 8px;
  white-space: nowrap;
  background-color: var(--colors-info-main);
  color: var(--colors-text-info);
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
}

.autocompleteProductCardDetails {
  overflow: hidden;
}

.autocompleteProductCardDetails mark {
  font-weight: var(--font-weight-semibold);
  background-color: transparent;
}

.autocompleteProductCardName {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
